export default __webpack_public_path__ + "static/media/traits-bear-2.7f6824cd.png";